import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Language } from '@posilka/shared';
import ru from '@posilka/client/i18n/locales/ru.json';
import uz from '@posilka/client/i18n/locales/uz.json';

export const resources = { uz: { translation: uz }, ru: { translation: ru } } as const;

/** Telegram language_code → ilova tili. O'zbek — asosiy (SPEC §2). */
export const detectLanguage = (code?: string): Language =>
  code?.startsWith('ru') ? Language.RU : Language.UZ;

export function initI18n(language: Language) {
  return i18n.use(initReactI18next).init({
    resources,
    lng: language,
    fallbackLng: Language.UZ,
    interpolation: { escapeValue: false },
  });
}

export default i18n;
